import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { NewsService } from '@mitsubishi/news/data-access';

@Component({
  selector: 'apm-news-admin-dialog-visibility-step',
  templateUrl: './news-admin-dialog-visibility-step.component.html',
  styleUrls: ['./news-admin-dialog-visibility-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewsAdminDialogVisibilityStepComponent implements OnInit {
  @Input() form!: UntypedFormGroup;

  users$ = this.newsService.getUsersTags();
  organisations$ = this.newsService.getOrganisationsTags();
  countries$ = this.newsService.getCountriesTags();
  orgTypes$ = this.newsService.getOrgTypesTags();

  constructor(private newsService: NewsService) {}

  ngOnInit(): void {}
}
